import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import lenderALogo from '../assets/lender-a.png';
import lenderBLogo from '../assets/lender-b.png';
import coins1 from '../assets/coins1.svg';

const Screen4: React.FC = () => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate('/screen5');
  };

  // Decorative asset

  return (
    <motion.div
      className="bg-[#f0effa] h-[100dvh] w-full relative overflow-y-auto overscroll-contain"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Title */}
      <motion.div
        className="absolute top-[64px] left-0 right-0 text-center"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        <h1 className="text-[35px] font-medium text-black font-['Bricolage_Grotesque',_sans-serif] leading-[45px]">
          Debt Consolidation
        </h1>
      </motion.div>

      {/* Purple Badge */}
      <motion.div
        className="absolute top-[126px] left-[84px] bg-[#9b86ea] rounded-[20px] px-[20px] py-[10px]"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.3, type: "spring" }}
      >
        <p className="text-white text-[14px] font-medium font-['Bricolage_Grotesque',_sans-serif]">
          Upto $5k savings found
        </p>
      </motion.div>

      {/* Subtitle */}
      <motion.p
        className="absolute top-[184px] left-[86px] text-[14px] font-medium text-black font-['Bricolage_Grotesque',_sans-serif]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        2 offers found across 50 providers
      </motion.p>

      {/* Lender A Card */}
      <motion.div
        className="absolute top-[217px] left-[48px] w-[294px] h-[264px] bg-white rounded-[30px] shadow-[6px_6px_0px_0px_#221a51]"
        initial={{ x: -50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.5 }}
        whileHover={{ y: -3, rotate: -0.5 }}
        whileTap={{ scale: 0.995 }}
      >
        {/* Lender Logo */}
        <img
          src={lenderALogo}
          alt="Lender A"
          className="absolute top-[14px] left-[24px] w-[49px] h-[47px] rounded-[12px] object-contain"
        />

        {/* Lender Name */}
        <p className="absolute top-[26px] left-[84px] text-[18px] font-medium text-black font-['Bricolage_Grotesque',_sans-serif]">
          Lender A
        </p>

        {/* Loan Details */}
        <div className="absolute top-[65px] left-[37px]">
          <p className="text-[15px] text-black font-normal font-['Bricolage_Grotesque',_sans-serif] leading-[20px]">
            Loan Amount: $25,000
            <br />
            Interest Rate: 12.55%
          </p>
        </div>

        {/* Savings Amount */}
        <p className="absolute top-[120px] left-[35px] text-[32px] font-medium text-black font-['Bricolage_Grotesque',_sans-serif]">
          $3,297
        </p>
        <p className="absolute top-[162px] left-[35px] text-[15px] text-black font-normal font-['Bricolage_Grotesque',_sans-serif]">
          potential savings
        </p>

        {/* View Details Button */}
        <button
          onClick={handleViewDetails}
          className="absolute bottom-[12px] left-[29px] w-[237px] bg-[#9b86ea] px-[24px] py-[12px] rounded-[50px] flex items-center justify-center gap-[10px] hover:bg-[#8b76da] transition-all"
        >
          <span className="text-white text-[14px] font-bold font-['Bricolage_Grotesque',_sans-serif]">
            View details
          </span>
        </button>

        {/* Decorative Coins (right side, centered with rotation) */}
        <motion.img
          src={coins1}
          alt=""
          className="absolute right-[16px] top-1/2 -translate-y-1/2 w-[50px] h-[22px] object-contain"
          animate={{ rotate: [20, 16, 20], y: [0, -2, 0] }}
          transition={{ duration: 3, repeat: Infinity }}
        />
      </motion.div>

      {/* Lender B Card */}
      <motion.div
        className="absolute top-[512px] left-[48px] w-[294px] h-[264px] bg-white rounded-[30px] shadow-[6px_6px_0px_0px_#221a51]"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.7 }}
        whileHover={{ y: -3, rotate: 0.5 }}
        whileTap={{ scale: 0.995 }}
      >
        {/* Lender Logo */}
        <img
          src={lenderBLogo}
          alt="Lender B"
          className="absolute top-[21px] left-[29px] w-[44px] h-[44px] rounded-[12px] object-contain"
        />

        {/* Lender Name */}
        <p className="absolute top-[32px] left-[103px] text-[18px] font-medium text-black font-['Bricolage_Grotesque',_sans-serif]">
          Lender B
        </p>

        {/* Loan Details */}
        <div className="absolute top-[72px] left-[37px]">
          <p className="text-[15px] text-black font-normal font-['Bricolage_Grotesque',_sans-serif] leading-[20px]">
            Loan Amount: $14,000
            <br />
            Interest Rate: 9.95%
          </p>
        </div>

        {/* Savings Amount */}
        <p className="absolute top-[127px] left-[35px] text-[32px] font-medium text-black font-['Bricolage_Grotesque',_sans-serif]">
          $2,844
        </p>
        <p className="absolute top-[169px] left-[35px] text-[15px] text-black font-normal font-['Bricolage_Grotesque',_sans-serif]">
          potential savings
        </p>

        {/* View Details Button */}
        <button
          onClick={handleViewDetails}
          className="absolute bottom-[12px] left-[29px] w-[237px] bg-[#9b86ea] px-[24px] py-[12px] rounded-[50px] flex items-center justify-center gap-[10px] hover:bg-[#8b76da] transition-all"
        >
          <span className="text-white text-[14px] font-bold font-['Bricolage_Grotesque',_sans-serif]">
            View details
          </span>
        </button>

        {/* Decorative Coins (right side, centered with rotation) */}
        <motion.img
          src={coins1}
          alt=""
          className="absolute right-[16px] top-1/2 -translate-y-1/2 w-[50px] h-[22px] object-contain"
          animate={{ rotate: [-15, -12, -15], y: [0, 2, 0] }}
          transition={{ duration: 3, repeat: Infinity }}
        />
      </motion.div>
    </motion.div>
  );
};

export default Screen4;
